// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2cCGo","noInteraction":"EventWrapper_noInteraction__2qu_J"};